













































































import { Component, Prop } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiDropdownMenu from '@/components/semantic-ui/DropdownMenu'
import UiShape from '@/components/semantic-ui/Shape'

import { Household, Household_User } from '@/datastore/models'

import { V1 } from '@/export'

import grocery from '@/store/modules/grocery'

import ImportModal from '../modals/ImportModal.vue'
import ImportingModal from '../modals/ImportingModal.vue'

@Component({
	components: {
		ImportModal,
		ImportingModal,
		UiButton,
		UiDropdownMenu,
		UiShape,
	},
})
export default class HouseholdCard extends UiShape {

	$refs!: {
		'import-modal': ImportModal
		'importing-modal': ImportingModal
	}

	@Prop({ required: true })
	readonly household!: Household

	inviteCode = ''

	get householdMembers(): Household_User[] {

		return grocery.householdMembers[this.household.$id] || []
	}

	closeInviteCode(): void {

		this.flipBack()
		this.inviteCode = ''
	}

	async copyInviteCode(): Promise<void> {

		if (navigator.clipboard) {
			await navigator.clipboard.writeText(this.inviteCode)
			this.$toast({ class: 'success', message: 'Invite code copied' })
		}
	}

	async createInviteCode(): Promise<void> {

		this.flipOver()
		this.inviteCode = await grocery.createInviteCode(this.household.$id)
	}

	async importPantry(data: V1.Schema) {

		const { pantryData } = this.$refs['import-modal']

		if (pantryData) {
			this.$refs['importing-modal'].show()
			await grocery.import({ householdId: this.household.$id, pantryData })
			this.$refs['importing-modal'].hide()
		}
	}

	showImportModal() {

		this.$refs['import-modal'].show()
	}

}

